import type { SerializedLexicalNode } from 'lexical/LexicalNode'
import type { SerializedLineBreakNode } from 'lexical'

export function isSerializedLineBreakNode(node: SerializedLexicalNode): node is SerializedLineBreakNode {
    return node.type === 'linebreak'
}
